import { render, staticRenderFns } from "./WerWirSind.vue?vue&type=template&id=734b6f87&scoped=true&"
import script from "./WerWirSind.vue?vue&type=script&lang=js&"
export * from "./WerWirSind.vue?vue&type=script&lang=js&"
import style0 from "./WerWirSind.vue?vue&type=style&index=0&id=734b6f87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734b6f87",
  null
  
)

export default component.exports